// extracted by mini-css-extract-plugin
export default {"loan-field-breakup__container":"HomeLoanSkeleton_loan-field-breakup__container__x6nrM"};